import React, { useLayoutEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { FloatingContactDock } from './FloatingContactDock';
import { EnquiryModalProvider } from '../../contexts/EnquiryModalContext';
export function Layout() {
  const {
    pathname,
    hash
  } = useLocation();

  // Behave like a normal page load: the new page appears already at the top,
  // with no visible scroll animation. Runs before paint so the old scroll position never flashes.
  useLayoutEffect(() => {
    const instant = 'instant' as ScrollBehavior;
    if (hash && hash !== '#enquire') {
      const target = document.getElementById(hash.slice(1));
      if (target) {
        target.scrollIntoView({
          behavior: instant
        });
        return;
      }
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: instant
    });
  }, [pathname, hash]);
  return <EnquiryModalProvider data-id="element-600" data-mp="1oq6ep1rfh3hr">
    <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-601" data-mp="1opn5c9fufnfc">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-full focus:bg-ink focus:px-4 focus:py-2 focus:text-white" data-id="element-602" data-mp="3n11xatl2e52e">
        Skip to content
      </a>
      <Header data-id="element-603" data-mp="3dba0dsphszur" />
      <main id="main" className="flex-1" data-id="element-604" data-mp="3d8ntzwec8qe4">
        <Outlet data-id="element-605" data-mp="38cp2hzxpqs9h" />
      </main>
      <Footer data-id="element-606" data-mp="38dgy3arb8pzr" />
      <FloatingContactDock data-id="element-607" data-mp="389t3e8a4pxjg" />
    </div>
    </EnquiryModalProvider>;
}